import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "./header";
import { Link } from "react-router-dom";
import $ from "jquery";
import WOW from "wowjs";

import { Container, Row, Col } from "reactstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Metatag from "../../hooks/Metatag";

export default function ThankYouPage() {
  return (
    <>
      <Header></Header>

      <Metatag title='Thankyou' description='Thankyou' keywords='Thankyou'/>

      {/* Visual Panel */}
      <Container fluid className="bg-visual-inside px-0" >
        <div className="visual-inside-big visual-container-inside">
          <Container >
            <Row className="g-md-0 rounded-4">
              <Col md={12}>
                <div className="py-md-4">
                  <div className="m-0 text-center py-xl-3 p-2 text-white">
                    <h1 className="fw-light text-white m-0 align-self-center wow fadeInUp">
                      Thank you
                    </h1>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>

      <Container className="my-5">
        <div className="m-0 text-center wow fadeInUp">
        <p className="m-0">Your request has been sent to GESH IITB.</p>
        <p>We shall get back to you at the earliest.</p>
        <div className="text-center mt-4">
            <Link to="/home" className="btn btn-secondary px-md-4 py-md-2 rounded-pill"><i class="bi bi-arrow-left me-1"></i>Back</Link>
        </div>
        </div>
      </Container>

      {/* Breadcrumb */}
      <Breadcrumb className="breadcrumb-panel mt-auto">
        <Breadcrumb.Item href={global.variables.strDomainUrl}>Home</Breadcrumb.Item>
        <Breadcrumb.Item active>Thankyou</Breadcrumb.Item>
      </Breadcrumb>
    </>
  );
}
